module.exports = {
    SCOPE: 'email',
    VERSION: 'v7.0'
};



// WEBPACK FOOTER //
// ./app/scripts/constants/_facebook.js